import { FiltersContext } from "@components/commerce/product-listing/filters/context/FiltersContext";
import { FiltersToolbar } from "@components/commerce/product-listing/filters/toolbar/FiltersToolbar";
import type { IPartFilter, IPartStoryTile } from "@contentful-api/types/contentful";
import type { Document } from "@contentful/rich-text-types";
import { Box } from "@ui/components/layout/box/Box";
import { sizes } from "@ui/design-tokens";
import type { FC } from "react";
import { useContext } from "react";
import { ProductList } from "./product-tile-list/ProductList";

interface IProductListingProps {
    listOfFilters: IPartFilter[];
    authorizationInvitation: Document;
    locale: string;
    widgetSize?: string;
    editorialWidgets?: IPartStoryTile[];
}

export const ProductListing: FC<IProductListingProps> = ({
    listOfFilters,
    authorizationInvitation,
    locale,
    widgetSize,
    editorialWidgets,
}) => {
    const { filtersDialogOpened } = useContext(FiltersContext);

    return (
        <>
            <Box
                data-testid="product-listing"
                sx={{
                    position: "sticky",
                    w: ["100%", "fit-content"],
                    top: [
                        `calc(${sizes.navBarCollapsedHeight} + 25px)`,
                        `calc(${sizes.navBarCollapsedHeight} + 25px)`,
                        `calc(${sizes.navBarCollapsedHeight} + 35px)`,
                    ],
                    zIndex: filtersDialogOpened ? 3 : 2,
                    boxSizing: "border-box",
                    px: [
                        "layoutMargin.mobile",
                        "layoutMargin.tab",
                        "layoutMargin.desktop",
                        "layoutMargin.desktop",
                    ],
                }}
            >
                <FiltersToolbar listOfFilters={listOfFilters} locale={locale} />
            </Box>
            <Box sx={{ position: "relative" }}>
                <Box
                    sx={{
                        position: "relative",
                        display: "block",
                    }}
                >
                    <ProductList
                        authorizationInvitation={authorizationInvitation}
                        widgetSize={widgetSize}
                        editorialWidgets={editorialWidgets}
                    />
                </Box>
            </Box>
        </>
    );
};
